import '../../assets/css/container/services/ladies.css';
import kidStyle from '../../assets/img/kids.png';
import LadiesBanner from '../../assets/img/ladies-banner.png';
import { HashLink } from "react-router-hash-link";
import { useState } from 'react';

const Ladies = () => {
  const categories = {
    Braids: [
      { name: "Box Braids", price: "$180 & UP" },
      { name: "Single Braids", price: "$180 & UP" },
      { name: "Boho Braids", price: "$200 & UP **Curly Hair Not Provided**" },
    ],
    Locs: [
      { name: "Soft Locs Up to Waist", price: "$200 & UP" },
      { name: "Soft Locs / Butt Length", price: "$250 & UP" },
      { name: "Butterfly Locs / Waist", price: "$180 & UP" },
      { name: "Butterfly Locs / Butt Length", price: "$200 & UP" },
      { name: "Goddess Locs", price: "$200 & UP" },
      { name: "Faux Locs / Waist", price: "$180 & UP" },
      { name: "Faux Locs / Butt Length", price: "$200 & UP" },
      { name: "Micro Locs", price: "$400 & UP" },
      { name: "Invisible Locs", price: "$120 & UP" },
      { name: "Re-Twist", price: "$85 & UP" },
    ],
    Twists: [
      { name: "2 Strand Twist", price: "$85 & UP" },
      { name: "Marley Twist (Special)", price: "$200 & UP" },
      { name: "Interlock Twist", price: "$120 & UP" },
      { name: "Senegalese Twist", price: "$180 & UP" },
    ],
    Cornrows: [
      { name: "3 Layer Cornrows", price: "$200 & UP" },
      { name: "2 Layer Cornrows", price: "$150 & UP" },
      { name: "2 Cornrows Up to Waist", price: "$50 & UP" },
      { name: "Tribal Weave", price: "$200 & UP" },
    ],
    Other: [
      { name: "Touch Ups", price: "$75 & UP" },
      { name: "Take Out Weave + Wash & Dry", price: "$75 & UP" },
      { name: "Take Out Braid Style + Wash & Dry", price: "$70 & UP" },
    ]
  };

  const kidServices = [
    { name: "Box Braids", price: "$130 & UP" },
    { name: "Feed-In Cornrows", price: "$75 & UP" },
    { name: "2 Layer Cornrows", price: "$100 & UP" },
    { name: "Boho Braids", price: "$150 & UP" },
    { name: "Senegalese Braids", price: "$150 & UP" },
  ];

  const [openCategory, setOpenCategory] = useState(null);

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  return (
    <section className="price-list fade-in">

      <div className="ladies-banner">
          <img src={LadiesBanner} alt="Ladies Banner" className="banner-img" />
          <div className="banner-overlay">
            <h2>Beauty. Confidence. Elegance.</h2>
            <p>Protective styles, natural care, and modern braids — tailored for every woman’s glow.</p>
          </div>
        </div>

      <p className="heading">
        <HashLink to='/gentlemen#' className="ladies-gent-heading">
          GO TO THE GENTLEMEN SERVICES
        </HashLink>
      </p>

      <div className="hero-banner">
        <h1>Kadi's Hair Gallery</h1>
        <h2>Price List</h2>
        <p className="intro-text">
          At Kadi’s Hair Gallery, every style is crafted with precision and care.
          Our stylists specialize in protective, elegant, and lasting looks designed
          to enhance your natural beauty.
        </p>
        <p className="disclaimer">All prices are subject to change.</p>
      </div>

      {/* Collapsible Service Categories */}
      <div className="categories-container">
        {Object.entries(categories).map(([category, services]) => (
          <div key={category} className="category-card">
            <div className="category-header" onClick={() => toggleCategory(category)}>
              <h3>{category}</h3>
              <span className={`arrow ${openCategory === category ? "open" : ""}`}>▼</span>
            </div>
            {openCategory === category && (
              <div className="service-list">
                {services.map((item, index) => (
                  <div key={index} className="service-item" data-aos="fade-up">
                    <p>{item.name}</p>
                    <span className="price">{item.price}</span>
                    <a href="tel:5714919196" className="book-now">📞 Book Now</a>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ✨ Kid Section ✨ */}
      <div className="kid-section">
        <h3 className="kid-heading">Kid Styles 💫</h3>
        <p className="kid-subtext">
          Fun, gentle, and stylish — designed to make every little one feel confident and happy!
        </p>

        <div className="kid-services">
          {kidServices.map((service, index) => (
            <div key={index} className="kid-card" data-aos="zoom-in">
              <p className="kid-name">{service.name}</p>
              <span className="kid-price">{service.price}</span>
            </div>
          ))}
        </div>

        <a href="tel:5714919196" className="kid-book-btn">📞 Book a Kid’s Appointment</a>
      </div>
    </section>
  );
};

export default Ladies;
